import DOMPurify from "dompurify";

// Defense in depth: any anchor that opens a new tab gets rel="noopener
// noreferrer", so callers that allow `target` (rich Help content, below) can
// never reintroduce reverse tabnabbing even if the authored markup omits rel.
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A" && node.getAttribute("target") === "_blank") {
    node.setAttribute("rel", "noopener noreferrer");
  }
});

export function sanitizeHtml(dirty, config) {
  return DOMPurify.sanitize(dirty || "", config);
}

// Rich, author-controlled Help content (Quill-authored article bodies and custom
// messages). Same XSS guarantees as sanitizeHtml (script / event handlers /
// javascript: URIs are still removed), but preserves `target` so authored
// "open in new tab" links keep working. The hook above force-sets rel on those
// links, so allowing target stays safe. RC#290 / #309 follow-up.
export function sanitizeRichHtml(dirty) {
  return sanitizeHtml(dirty, { ADD_ATTR: ["target"] });
}
